const reviews = [
    {
        id: 1,
        platform: "Google",
        rating: 4,
        date: "2023-11-15T10:00:00Z",
        text: "Отличный сервис!",
    },
    {
        id: 2,
        platform: "Яндекс",
        rating: 3,
        date: "2023-11-14T09:00:00Z",
        text: "Хорошо, но есть недочеты.",
    },
    {
        id: 3,
        platform: "2ГИС",
        rating: 5,
        date: "2023-11-13T08:00:00Z",
        text: "Прекрасно!",
    },
    {
        id: 4,
        platform: "Google",
        rating: 2,
        date: "2023-11-12T07:00:00Z",
        text: "Не взяли на работку(((",
    },
    {
        id: 5,
        platform: "Яндекс",
        rating: 1,
        date: "2023-11-11T06:00:00Z",
        text: "Хотелось бы большего",
    },
    {
        id: 6,
        platform: "2ГИС",
        rating: 5,
        date: "2023-11-10T05:00:00Z",
        text: "Замечательная поддержка, всем доволен!",
    },
    {
        id: 7,
        platform: "Google",
        rating: 3,
        date: "2023-11-09T04:00:00Z",
        text: "Неплохо, но есть куда улучшаться.",
    },
    {
        id: 8,
        platform: "Яндекс",
        rating: 4,
        date: "2023-11-08T03:00:00Z",
        text: "Отличные ребята! ",
    },
    {
        id: 9,
        platform: "2ГИС",
        rating: 2,
        date: "2023-11-07T02:00:00Z",
        text: "Ожидал большего, но все равно неплохо.",
    },
    {
        id: 10,
        platform: "Google",
        rating: 5,
        date: "2023-11-06T01:00:00Z",
        text: "Лучший сервис в моей жизни!",
    },
];

export default reviews;
